export const GET_SPEAKERS_LIST_LOADING = "GET_SPEAKERS_LIST_LOADING";
export const SET_SPEAKERS_LIST = "SET_SPEAKERS_LIST";
export const ADD_SPEAKER_LOADING = "ADD_SPEAKER_LOADING";
export const GET_SPEAKER_DETAILS_LOADING = "GET_SPEAKER_DETAILS_LOADING";
export const SET_SPEAKER_DETAILS = "SET_SPEAKER_DETAILS"
export const GET_SPEAKER_DETAILS = "GET_SPEAKER_DETAILS";
export const DELETE_SPEAKER_LOADING = "DELETE_SPEAKER_LOADING";
export const GET_EVENT_SPEAKER_FILTER_LOADING = "GET_EVENT_SPEAKER_FILTER_LOADING";
